import type { Translations } from '../types';
import { events } from '../lib/firebase';

interface CTAProps {
  t: Translations;
  onGetStarted: () => void;
  isMaintenanceMode?: boolean;
}

export function CTA({ t, onGetStarted, isMaintenanceMode = false }: CTAProps) {
  const handleClick = () => {
    if (isMaintenanceMode) return;
    events.ctaClick('get_started_free', 'cta_section');
    onGetStarted();
  };

  return (
    <section className="py-12 sm:py-20 bg-gradient-to-br from-vinotinto to-vinotinto-dark">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center text-white">
        <h2 className="mb-4 sm:mb-6 text-white text-2xl sm:text-3xl font-bold">{t.ctaTitle}</h2>
        <p className="text-base sm:text-xl mb-6 sm:mb-8 opacity-90">{t.ctaDesc}</p>
        <button
          onClick={handleClick}
          disabled={isMaintenanceMode}
          className={`px-8 py-4 rounded-lg transition-colors font-semibold text-lg ${
            isMaintenanceMode
              ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
              : 'bg-white text-vinotinto hover:bg-gray-100'
          }`}
        >
          {isMaintenanceMode ? t.comingSoon : t.getStartedFree}
        </button>
      </div>
    </section>
  );
}
